<template>
  <div class="error__wrapper" @click="closeErrorModal">
    <div class="error__modal">
      <div class="error__image"></div>
      <h3 class="error__title">{{ title }}</h3>
      <p class="error__text">{{ text }}</p>
      <button class="button button--black" @click="emit('close')">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
//import { config } from "../constants";
defineProps({
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  buttonLabel: {
    type: String,
    required: true,
  },
});
const emit = defineEmits(["close"]);

function closeErrorModal(e: any) {
  if (e.target.classList.contains("error__wrapper")) {
    emit("close");
  }
}

// used to be the created function
document.addEventListener("keydown", (e) => {
  if (e.code === "Escape") {
    emit("close");
  }
});
////
</script>

<style lang="less" scoped>
@import (reference) "../less/main";
@import (reference) "../../public/less/custom";

.error__wrapper {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  .color-o(@general-black, 0.5);
  background: @color-o;

  .with-ad & {
    width: ~"calc(100% - 300px)";

    @media @mobile {
      width: 100%;
    }
  }
}

.error__modal {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: ~"calc(100% - 64px)";
  max-width: 480px;
  border-radius: 24px;
  padding: 40px;
  background: @general-white;
  box-shadow: 0px 0px 80px rgba(0, 0, 0, 0.1);

  @media @mobile {
    padding: 24px 16px;
  }

  @media @mobile-s {
    width: ~"calc(100% - 32px)";
    padding: 16px;
  }

  .with-ad & {
    @media @with-ad-mobile {
      padding: 24px 16px;
    }

    @media @with-ad-mobile-s {
      width: ~"calc(100% - 32px)";
      padding: 16px;
    }
  }
}

.error__image {
  width: 160px;
  height: 160px;
  margin-bottom: 16px;
  border-radius: 160px;
  @color: replace(@accent-red, "#", "%23");
  background: url("data:image/svg+xml,%3Csvg width='132' height='87' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M82.5 32.586c0-.371.097-1.05.357-1.684.344-.83.812-1.202 1.706-1.202.894 0 1.36.371 1.705 1.202.26.634.358 1.313.358 1.684v1.651c0 1.14.92 2.063 2.062 2.063a2.06 2.06 0 002.061-2.063v-1.65c0-.867-.163-2.042-.672-3.265-.942-2.262-2.799-3.747-5.514-3.747-2.716 0-4.573 1.485-5.514 3.747a8.69 8.69 0 00-.674 3.264v1.651c0 1.14.922 2.063 2.062 2.063a2.06 2.06 0 002.063-2.063v-1.65zm-37.125 0c0-.371.096-1.05.357-1.684.345-.83.811-1.202 1.705-1.202.895 0 1.363.371 1.706 1.202.26.634.357 1.313.357 1.684v1.651c0 1.14.92 2.063 2.063 2.063 1.14 0 2.063-.922 2.063-2.063v-1.65a8.69 8.69 0 00-.674-3.265c-.942-2.262-2.799-3.747-5.515-3.747-2.715 0-4.572 1.485-5.514 3.747a8.684 8.684 0 00-.672 3.264v1.651c0 1.14.92 2.063 2.06 2.063a2.06 2.06 0 002.064-2.063v-1.65zm14.129 24.188c.199-.317.693-.901 1.49-1.507 1.349-1.03 2.99-1.642 5.006-1.642 2.015 0 3.657.611 5.005 1.642.798.606 1.292 1.19 1.491 1.507a2.067 2.067 0 002.84.665 2.067 2.067 0 00.668-2.839c-.447-.714-1.266-1.677-2.496-2.618C71.472 50.435 68.964 49.5 66 49.5c-2.964 0-5.472.935-7.508 2.482-1.23.941-2.049 1.904-2.496 2.618a2.067 2.067 0 00.667 2.84 2.067 2.067 0 002.84-.666z' fill='@{color}'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.25 74.25V6.16C8.25 2.756 11.008 0 14.474 0h103.055c3.437 0 6.221 2.784 6.221 6.16v68.09h6.209c1.127 0 2.042.886 2.042 2.04v4.147a6.187 6.187 0 01-6.222 6.188H6.222C2.784 86.625 0 83.882 0 80.437v-4.146c0-1.127.928-2.042 2.042-2.042H8.25zm111.375 0V6.221a2.099 2.099 0 00-2.105-2.098H14.48a2.096 2.096 0 00-2.105 2.098v68.027h107.25zm-6.174-66c1.134 0 2.049.886 2.049 2.021v57.832c0 1.114-.928 2.02-2.049 2.02H18.549c-1.134 0-2.049-.885-2.049-2.02V10.271c0-1.114.927-2.022 2.049-2.022h94.902zM111.375 66h-90.75V12.375h90.75V66zM4.125 80.437v-2.062h123.75v2.062c0 1.14-.928 2.063-2.104 2.063H6.229c-1.162 0-2.104-.956-2.104-2.063z' fill='@{color}'/%3E%3C/svg%3E")
    lighten(@accent-red, 40) center / 96px no-repeat;

  @media @mobile {
    width: 120px;
    height: 120px;
    margin-bottom: 8px;
    background-size: 80px;
  }

  .with-ad & {
    @media @with-ad-mobile {
      width: 120px;
      height: 120px;
      margin-bottom: 8px;
      background-size: 80px;
    }
  }
}

.error__title {
  width: 100%;
  margin-bottom: 16px;
  font-weight: @bold;
  font-size: 24px;
  line-height: 125%;
  color: @accent-red;
  text-align: center;

  @media @mobile {
    margin-bottom: 8px;
    font-size: 20px;
  }

  .with-ad & {
    @media @with-ad-mobile {
      margin-bottom: 8px;
      font-size: 20px;
    }
  }
}

.error__text {
  width: 100%;
  margin-bottom: 56px;
  font-size: 18px;
  line-height: 28px;
  color: @general-black;
  text-align: center;

  @media @mobile {
    margin-bottom: 24px;
    font-size: 16px;
  }

  .with-ad & {
    @media @with-ad-mobile {
      margin-bottom: 24px;
      font-size: 16px;
    }
  }
}
</style>
